export default class CertificadoItem {
  constructor() {
    this.message = "";
    this.variant = "";
    this.result = "";
    this.certificado = null;
  }

  update(item) {
    this.numero = item.message;
    this.data = item.variant;
    this.local = item.result;
    this.certificado = item.certificado;
  }
}
